import { CommonModule } from '@angular/common';
import { NgModule, SecurityContext } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MarkdownModule } from 'ngx-markdown';
import { ToastrModule } from 'ngx-toastr';
import { TruncateTextPipe } from './pipes/truncate-text.pipe';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { AuthAlertComponent } from './components/auth-alert/auth-alert.component';
import { ChatConfigComponent } from './components/chat-config/chat-config.component';
import { ChatHistoryComponent } from './components/chat-history/chat-history.component';
import { LoaderComponent } from './components/loader/loader.component';
import { RangeSliderComponent } from './components/range-slider/range-slider.component';
import { WelcomeScreenComponent } from './components/welcome-screen/welcome-screen.component';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { DateAgoPipe } from './pipes/dateago.pipe';
import { GroupByDatePipe } from './pipes/group-by-date.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { SortByTimeTitlePipe } from './pipes/sort-by-time-title.pipe';
import { WorkPlayToggleTabComponent } from './components/work-play-toggle-tab/work-play-toggle-tab.component';
import { DisclaimerMsgComponent } from './components/disclaimer-msg/disclaimer-msg.component';
import { FileLoaderComponent } from './components/file-loader/file-loader.component';
import { ConsentModalComponent } from './components/consent-modal/consent-modal.component';
import { ChatTextareaComponent } from './components/chat-textarea/chat-textarea.component';
import { PromptListComponent } from './components/prompt-list/prompt-list.component';
import { SvgIconComponent } from './components/svg-icon/svg-icon.component';

@NgModule({
    declarations: [
        ChatTextareaComponent,
        PromptListComponent,
        SidebarComponent,
        ConsentModalComponent,
        LoaderComponent,
        SafePipe,
        CapitalizePipe,
        DateAgoPipe,
        GroupByDatePipe,
        SortByTimeTitlePipe,
        WorkPlayToggleTabComponent,
        DisclaimerMsgComponent,
        ChatHistoryComponent,
        ChatConfigComponent,
        WelcomeScreenComponent,
        AuthAlertComponent,
        RangeSliderComponent,
        FileLoaderComponent,
        SvgIconComponent,
    ],
    imports: [
        TruncateTextPipe,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        ToastrModule.forRoot({
            timeOut: 5000,
            positionClass: 'toast-bottom-right',
            preventDuplicates: true,
        }),
        MarkdownModule.forRoot({
            sanitize: SecurityContext.NONE
        }),
        // NgbTypeaheadModule,
        RouterModule,
        NgbDropdownModule
    ],
    exports: [
        ChatTextareaComponent,
        PromptListComponent,
        SidebarComponent,
        LoaderComponent,
        SafePipe,
        CapitalizePipe,
        DateAgoPipe,
        GroupByDatePipe,
        SortByTimeTitlePipe,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        MarkdownModule,
        WorkPlayToggleTabComponent,
        // NgbTypeaheadModule,
        TruncateTextPipe,
        ChatHistoryComponent,
        ChatConfigComponent,
        WelcomeScreenComponent,
        AuthAlertComponent,
        RangeSliderComponent,
        DisclaimerMsgComponent,
        FileLoaderComponent,
        ConsentModalComponent,
        SvgIconComponent,
    ]
})
export class SharedModule { }
